import React, { useEffect } from "react";
import { useEventBus } from "src/hooks";
import { ON_RENDER_EVOLUTIVE_CROSS_FOOTER_OPTIONS } from "src/hooks/EventBus/eventTypes";
import SurveysCollapsibleList from "../sections/SurveyCollapsibleList";
import CrossQuestionCollapsibleList from "./CrossQuestionCollapsibleList";
import * as Ui from "./styles";

function StepOne({
  // Relacionado a visibilidade do passo
  visible = false,
  // Titulo da pesquisa
  surveyTitle,
  // Titulo da questão principal selecionada no dashboard
  questionTitle,
  // Id da pesquisa
  surveyId,
  // Id da questão
  questionId,
  // Id do Cliente
  customerId,
}) {

  // event bus
  const eventBus = useEventBus();

  /**
   * Effects: O step um nunca deve ter o footer options como visible.
   */
   useEffect(() => {
    eventBus.notify(ON_RENDER_EVOLUTIVE_CROSS_FOOTER_OPTIONS, false);
  }, []);

  return (
    <Ui.Container visible={visible}>
      <CrossQuestionCollapsibleList
        surveyId={surveyId}
        questionId={questionId}
        customerId={customerId}
        surveyTitle={surveyTitle}
        questionTitle={questionTitle}
      />
      <SurveysCollapsibleList
        customerId={customerId}
        dashboardSurveyId={surveyId}
      />
    </Ui.Container>
  );
};

export default React.memo(StepOne);
